/**
 * CrewMember entity — crew_members.CrewMember (xsite/crew_members/models.py).
 */

import { createResourceApi } from '../shared/resourceApi';
import { createResourceHooks } from '../shared/createResourceHooks';
import type { Project } from './project';

export interface CrewMemberProjectStatistics {
  total_projects: number;
  active_projects: number;
  completed_projects: number;
}

export interface CrewMember {
  id: number;
  first_name?: string;
  last_name?: string;
  display_first_name?: string;
  display_last_name?: string;
  email?: string;
  display_email?: string;
  profession?: { id: number; name: string } | null;
  company?: { id: number; company_name?: string; telephone?: string; mobile?: string } | null;
  user?: { id: number } | null;
  default_hourly_rate?: number | string | null;
  default_daily_rate?: number | string | null;
  // Detail-only: nested by CrewMemberDetailSerializer
  active_projects?: Project[];
  project_statistics?: CrewMemberProjectStatistics;
}

export const crewMemberApi = createResourceApi<CrewMember>('crew/api/crew');

export const {
  keys: crewMemberKeys,
  useList: useCrewMembers,
  useDetail: useCrewMember,
  useCreate: useCreateCrewMember,
  useUpdate: useUpdateCrewMember,
  useRemove: useDeleteCrewMember,
} = createResourceHooks(crewMemberApi, {
  name: 'crew',
  model: 'crew_members.crewmember',
  detailRelatedModels: ['projects.project', 'projects.projectstaff'],
});
